import { create } from "zustand";

const CSV_IMPORT_POLL_INTERVAL_MS = 3_000;
const CSV_IMPORT_WINDOW_MS = 60_000;

type GuestFeedbackCsvImportState = {
  isCsvImportInProgress: boolean;
  notifyCsvUploaded: () => void;
  notifyCsvDeleted: () => void;
};

let windowTimeout: ReturnType<typeof setTimeout> | undefined;

export const useGuestFeedbackCsvImport = create<GuestFeedbackCsvImportState>(
  (set) => ({
    isCsvImportInProgress: false,
    notifyCsvUploaded: () => {
      set({ isCsvImportInProgress: true });
      if (windowTimeout) clearTimeout(windowTimeout);
      windowTimeout = setTimeout(
        () => set({ isCsvImportInProgress: false }),
        CSV_IMPORT_WINDOW_MS,
      );
    },
    notifyCsvDeleted: () => {
      if (windowTimeout) clearTimeout(windowTimeout);
      windowTimeout = undefined;
      set({ isCsvImportInProgress: false });
    },
  }),
);

export { CSV_IMPORT_POLL_INTERVAL_MS, CSV_IMPORT_WINDOW_MS };
